import { render } from "./Crates.vue?vue&type=template&id=0ce1e9d7"
import script from "./Crates.vue?vue&type=script&lang=ts"
export * from "./Crates.vue?vue&type=script&lang=ts"
script.render = render

export default script